// extracted by mini-css-extract-plugin
export var borderRadius = "_bw-4";
export var large = "_bw-3";
export var logoContainer = "_bw-0";
export var nameLogo = "_bw-2";
export var small = "_bw-1";